import React from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import useAwardSearch from "./useAwardSearch";

// Facet display names. Empty selects show these as a placeholder (no floating
// MUI label) so the controls read cleanly whether inline or in the panel.
export const FACET_LABELS = {
  cat: "Category",
  level: "Level",
  kind: "Kind",
  org: "Organization",
  acad: "Academy",
  year: "Active in year",
};

// Year facet (Awardees): an awardee matches if their award-year span covers it.
const CURRENT_YEAR = new Date().getFullYear();
export const YEAR_OPTIONS = Array.from(
  { length: CURRENT_YEAR - 1980 + 1 },
  (_, i) => {
    const y = String(CURRENT_YEAR - i);
    return { value: y, label: y };
  }
);

// Academy facet (Awardees): value = the awardee_summary flag column.
export const ACADEMY_OPTIONS = [
  { value: "NAM", label: "Nat'l Academy of Medicine" },
  { value: "NAE", label: "Nat'l Academy of Engineering" },
  { value: "NAS", label: "Nat'l Academy of Sciences" },
  { value: "NAI", label: "Nat'l Academy of Inventors" },
  { value: "AAS", label: "American Academy of Arts & Sciences" },
];

// A compact URL-bound facet dropdown. The empty state shows the facet name as a
// placeholder. Used both inline in the search shell (Awardees: Academy / Active
// in year) and inside the Awards Advanced panel (Category / Level / Kind).
export default function FacetSelect({ facet, options, className, minWidth }) {
  const { params, setParams } = useAwardSearch();
  const value = params[facet] || "";
  return (
    <FormControl
      size="small"
      className={className}
      sx={minWidth ? { minWidth } : undefined}
    >
      <Select
        value={value}
        displayEmpty
        onChange={(e) => setParams({ [facet]: e.target.value || "", page: 1 })}
        renderValue={(v) =>
          v ? options.find((o) => o.value === v)?.label ?? v : FACET_LABELS[facet]
        }
        sx={{ color: value ? "text.primary" : "text.secondary" }}
      >
        <MenuItem value="">
          <em>Any {FACET_LABELS[facet].toLowerCase()}</em>
        </MenuItem>
        {options.map((o) => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
